import {
  styled,
  Dialog,
  dialogClasses,
  DialogContent,
  DialogActions,
} from '@mui/material';

export const DialogImportVehiclesFromCSVContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    width: '100%',
  },
});

export const DialogImportVehiclesFromCSVContent = styled(DialogContent)(
  ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
);

export const DialogImportVehiclesFromCSVActions = styled(DialogActions)({
  justifyContent: 'space-between',
});
